<div [formGroup]="group">
  <input
    type="checkbox"
    [id]="control.name"
    [value]="true"
    [formControlName]="control.name"
    [attr.aria-required]="isRequired ? 'true' : 'false'"
    [attr.aria-invalid]="control.hasError ? 'true' : null"
    (change)="onChange()"
  />
  <label
    [for]="control.name"
    [internalInnerHtml]="control.label"
    [userEventSource]="userEventSource"
    [ngClass]="{ 'form-label--error': formState.submitted && group.controls[control.name].errors }"
  ></label>
</div>
